import { FC, useState } from 'react';
import { Hidden } from 'react-grid-system';
import { useHistory } from 'react-router';

import { verifactu } from 'modules/Documents/List/messages';
import useTranslations from 'modules/I18n/hooks/useTranslations';
import { MODAL_WIDTH_SMALL, useCloseModal } from 'modules/Modals';
import { Dialog } from 'modules/Modals/components/Dialog';
import { ModalTypes } from 'modules/Modals/constants';
import useModalFlags, { ModalFlag } from 'modules/Modals/hooks/useModalFlags';
import Separator from 'modules/Settings/components/Separator';
import { Text, Button, Img, Checkbox, Box } from 'modules/Ui';
import { ROUTES } from 'pages/documents/routesMap';

const VerifactuInfoDialog: FC = () => {
  const closeModal = useCloseModal();
  const { t } = useTranslations();
  const { setFlag } = useModalFlags();
  const [checked, setChecked] = useState(false);
  const history = useHistory();
  const onConfirm = async () => {
    if (checked) {
      setFlag({
        flag: ModalFlag.HIDE_TEST_INVOICE_WARNING,
        status: true,
      });
    }
    closeModal();
  };

  const handleCancel = () => {
    history.push(ROUTES.DOCUMENTS);
    closeModal();
  };

  const handleClose = () => {
    closeModal();
  };

  return (
    <Dialog
      dialogWidth={{ _: 'calc(100vw - 32px)', sm: MODAL_WIDTH_SMALL }}
      onClose={handleClose}
      title={t(verifactu.createButtonDialogTitle)}
      buttonPrimary={
        <Button onClick={onConfirm} variant="secondary">
          {t(verifactu.createButtonDialogButtonAction)}
        </Button>
      }
      buttonSecondary={
        <Hidden xs>
          <Button
            onClick={handleCancel}
            marginBottom={{ _: '16px', sm: '0' }}
            variant="stroke"
          >
            {t(verifactu.createButtonDialogButtonCancel)}
          </Button>
        </Hidden>
      }
      content={
        <>
          <Box textAlign="center" marginBottom="16px">
            <Img src="/assets/empty-documents.svg" width={134} />
          </Box>
          <Text
            color="gray800"
            fontSize={16}
            fontWeight={600}
            lineHeight={26}
            marginBottom="16px"
          >
            {t(verifactu.createButtonDialogSubtitle)}
          </Text>
          <Text
            color="gray600"
            fontSize={16}
            lineHeight={22}
            marginBottom="16px"
          >
            {t(verifactu.createButtonDialogText01)}
          </Text>
          <Text
            color="gray600"
            fontSize={16}
            lineHeight={22}
            marginBottom="24px"
          >
            {t(verifactu.createButtonDialogText02)}
          </Text>
          <Checkbox
            id="hide-modal-check"
            checked={checked}
            onChange={(e) => {
              setChecked(e.target.checked);
            }}
            label={t(verifactu.createButtonDialogLabelCheck)}
            marginBottom="32px"
          />
          <Separator marginBottom="0" />
        </>
      }
      id={ModalTypes.DELETE_BUSINESS}
    />
  );
};

export default VerifactuInfoDialog;
